// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalLoanOnline_container__EPW_B","heading":"PersonalLoanOnline_heading__1bAXv","list":"PersonalLoanOnline_list__2l-IR","footer":"PersonalLoanOnline_footer__1kvN9"};